export const STARBURST_URL =
  '//images.babylist.com/image/upload/v1693596817/DME/free-gift-startburst.svg'
